import React from 'react';
import AppIcon from './app-icon';
import Can from './ability';

/**
 * iOS 风格的应用图标组组件 - 响应式网格布局
 * @param {Object} props
 * @param {Array} props.items - 图标数据数组，每项包含: id, href, title, icon, color, permission(可选), condition(可选)
 * @param {string} props.className - 额外类名
 * @param {string} props.cols - 列数配置，默认 '4-4-6-6-8' (xs-sm-md-lg-xl)，少于4个图标时自动使用 flex 布局
 */
const AppIconGroup = ({ items, className = '', cols = '4-4-6-6-8' }) => {
  // 过滤掉条件为 false 的项
  const filteredItems = items.filter(item => item.condition !== false);
  const itemCount = filteredItems.length;
  
  // 如果图标数量小于4个，使用 flex 布局居左排列
  if (itemCount < 4) {
    return (
      <div className={`px-4 py-2 ${className}`}>
        <div className="flex flex-wrap gap-[55px] justify-start">
          {filteredItems.map((item) => {
            // 如果有权限控制，使用 Can 组件包裹
            if (item.permission) {
              return (
                <Can key={item.id} action={item.permission.action} subject={item.permission.subject}>
                  <AppIcon
                    href={item.href}
                    title={item.title}
                    icon={item.icon}
                    color={item.color}
                    onClick={item.onClick}
                  />
                </Can>
              );
            }
            
            // 没有权限控制，直接渲染
            return (
              <AppIcon
                key={item.id}
                href={item.href}
                title={item.title}
                icon={item.icon}
                color={item.color}
                onClick={item.onClick}
              />
            );
          })}
        </div>
      </div>
    );
  }
  
  // 图标数量 >= 4，使用网格布局
  const [xs, sm, md, lg, xl] = cols.split('-').map(Number);
  const gridClasses = `grid-cols-${xs} sm:grid-cols-${sm} md:grid-cols-${md} lg:grid-cols-${lg} xl:grid-cols-${xl}`;

  return (
    <div className={`px-4 py-2 ${className}`}>
      <div className={`grid ${gridClasses} gap-3 md:gap-4`}>
        {filteredItems.map((item) => {
          // 如果有权限控制，使用 Can 组件包裹
          if (item.permission) {
            return (
              <Can key={item.id} action={item.permission.action} subject={item.permission.subject}>
                <AppIcon
                  href={item.href}
                  title={item.title}
                  icon={item.icon}
                  color={item.color}
                  onClick={item.onClick}
                />
              </Can>
            );
          }
          
          // 没有权限控制，直接渲染
          return (
            <AppIcon
              key={item.id}
              href={item.href}
              title={item.title}
              icon={item.icon}
              color={item.color}
              onClick={item.onClick}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AppIconGroup;
